var _path, _g, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wallet-add",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.319,
    height: 34.319,
    viewBox: "0 0 34.319 34.319",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.53,7.221a6.539,6.539,0,0,0-1.072-.071H1.158A7.61,7.61,0,0,0,0,7.236,4.351,4.351,0,0,1,.829,6.12L5.477,1.459a5.04,5.04,0,0,1,7.093,0l2.5,2.531A4.825,4.825,0,0,1,16.53,7.221Z",
    transform: "translate(8.853 2.86)",
    fill: "none",
    stroke: "#005da8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.43 21.449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M11.44,5.72a5.607,5.607,0,0,1-.829,2.946,5.7,5.7,0,0,1-9.781,0A5.607,5.607,0,0,1,0,5.72a5.72,5.72,0,1,1,11.44,0Z",
    fill: "none",
    stroke: "#005da8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    "data-name": "Group",
    transform: "translate(3.592 3.603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M4.261,0H0",
    transform: "translate(0 2.088)",
    fill: "none",
    stroke: "#005da8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0V4.276",
    transform: "translate(2.128)",
    fill: "none",
    stroke: "#005da8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H34.319V34.319H0Z",
    fill: "none",
    opacity: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M28.6,7.15V14.3a6.755,6.755,0,0,1-7.15,7.15H8.051a5.138,5.138,0,0,0,1.13-1.344,5.607,5.607,0,0,0,.829-2.946A5.715,5.715,0,0,0,0,13.384V7.15C0,3.26,2.345.543,5.992.086A7.61,7.61,0,0,1,7.15,0h14.3a6.539,6.539,0,0,1,1.072.071C26.211.5,28.6,3.232,28.6,7.15Z",
    transform: "translate(2.86 10.01)",
    fill: "none",
    stroke: "#005da8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M7.15,0H2.86a2.86,2.86,0,0,0,0,5.72H7.15",
    transform: "translate(24.309 17.874)",
    fill: "none",
    stroke: "#005da8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletAdd);
export default __webpack_public_path__ + "static/media/wallet-add.545761fb6864d427b60d3bc5658c2096.svg";
export { ForwardRef as ReactComponent };